const PERFORMANCE_TRACE_FLAG = "__VILNIUS_PERFORMANCE_TRACE__";

/** Records opt-in browser performance measures without affecting normal play. */
export function tracePerformanceMeasure(name: string, startedAt: number): void {
  const traceGlobal = globalThis as typeof globalThis & Record<string, unknown>;
  if (traceGlobal[PERFORMANCE_TRACE_FLAG] !== true) return;
  performance.measure(`vilnius:${name}`, {
    start: startedAt,
    end: performance.now(),
  });
}
